// Cars.jsx - სრულად განახლებული ფაილი
// ეს ფაილი ჩაანაცვლე შენს Cars.jsx-ს

import React from 'react';
import Styles from './Car.module.css';
import Card from './Card';
// დავამატე ეს იმპორტი
import { baseCarPrices } from './carpages/HeroForm/carPrices';

import Micra from '../../images/cars/micra.png';
import Yaris from '../../images/cars/yaris.png';
import Logan from '../../images/cars/logan.png';
import Corolla from '../../images/cars/corolla.png';
import Sandero from '../../images/cars/sandero.png';
import Daster from '../../images/cars/daster.jpg';
import Tucson from '../../images/cars/tucson.avif';
import Prado from '../../images/cars/prado.png';
import Fortuner from '../../images/cars/fortuner.png';
import Rav4 from '../../images/cars/Rav4_2021.jpg';
import Creta from '../../images/cars/creta.jpg';

import { Helmet } from 'react-helmet';

function Cars() {
    return (
        <section className={Styles.featured_car} id="featured_car">
            <Helmet>
                <title>Cars</title>
            </Helmet>
            <div className={Styles.container}>
                <div className={Styles.title_wrapper}>
                    <h2 className={Styles.section_title}>AVIS CARS</h2>
                </div>

                <ul className={Styles.featured_car_list}>

                    <Card
                        image={Micra}
                        model='Nissan Micra'
                        group='Group_A'
                        People='4 People'
                        fuel='petrol'
                        bag='1'
                        transmission='Automatic'
                        price={baseCarPrices['Nissan Micra']}
                        link='/nissan_micra'
                    />

                    <Card
                        image={Yaris}
                        model='Toyota Yaris'
                        group='Group_B'
                        People='4 People'
                        fuel='petrol'
                        bag='1'
                        transmission='Automatic'
                        price={baseCarPrices['Toyota Yaris']}
                        link='/toyoya_yarus'
                    />

                    <Card
                        image={Logan}
                        model='Renault Logan'
                        group='Group_C'
                        People='4 People'
                        fuel='petrol'
                        bag='3'
                        transmission='Automatic/Manual'
                        price={baseCarPrices['Renault Logan']}
                        link='/Renault_Logan'
                    />

                    <Card
                        image={Corolla}
                        model='Toyota Corolla'
                        group='Group_D'
                        People='5 People'
                        fuel='petrol'
                        bag='3'
                        transmission='Automatic'
                        price={baseCarPrices['Toyota Corolla']}
                        link='/Toyota_Corolla'
                    />

                    <Card
                        image={Sandero}
                        model='Renault Sandero'
                        group='Group_P'
                        People='4 People'
                        fuel='petrol'
                        bag='1'
                        transmission='Automatic'
                        price={baseCarPrices['Renault Sandero']}
                        link='/Renault_Sandero'
                    />

                    <Card
                        image={Daster}
                        model='Renault Duster'
                        group='Group_F'
                        People='5 People'
                        fuel='petrol'
                        bag='3'
                        transmission='Manual'
                        price={baseCarPrices['Renault Duster']}
                        link='/Renault_daster'
                    />

                    <Card
                        image={Tucson}
                        model='Hyunda Tucson'
                        group='Group_G'
                        People='5 People'
                        fuel='petrol'
                        bag='4'
                        transmission='Automatic'
                        price={baseCarPrices['Hyundai Tucson']}
                        link='/Hyundai_Tucson'
                    />

                    <Card
                        image={Rav4}
                        model='Toyota Rav4'
                        group='Group_G'
                        People='5 People'
                        fuel='petrol'
                        bag='4'
                        transmission='Automatic'
                        price={baseCarPrices['Toyota Rav4']}
                        link='/Rav_fore'
                    />

                    <Card
                        image={Creta}
                        model='Hyundai Creta'
                        group='Group_G'
                        People='5 People'
                        fuel='petrol'
                        bag='4'
                        transmission='Automatic'
                        price={baseCarPrices['Hyundai Creta']}
                        link='/Hyundai_Creta'
                    />

                    <Card
                        image={Fortuner}
                        model='Toyota Fortuner'
                        group='Group_Q'
                        People='5 People'
                        fuel='petrol'
                        bag='4'
                        transmission='Automatic/Manual'
                        price={baseCarPrices['Toyota Fortuner']}
                        link='/Toyota_Fortuner'
                    />

                    <Card
                        image={Prado}
                        model='Toyota Prado'
                        group='Group_H'
                        People='5 People'
                        fuel='petrol'
                        bag='4'
                        transmission='Automatic/Manual'
                        price={baseCarPrices['Toyota Prado']}
                        link='/Toyota_Prado'
                    />

                </ul>
            </div>
        </section>
    );
}

export default Cars;